import type { FaireThemeEntity } from "../../entity_types/theme";

export const board_demo_r_wd64rb2zkz_thi_e3064223f2: FaireThemeEntity = {
  token: "board_demo_r_wd64rb2zkz_thi_e3064223f2",
  type: "theme",
  retailerToken: "r_wd64rb2zkz",
  name: "Pure & Organic Play",
  description:
    "Curated essentials made from organic cotton and bamboo, perfect for parents who prioritize high-quality, non-toxic, and sustainable babywear.",
  bgColor: "#F4EDE3",
  productTokens: [],
  coverImageUrl:
    "https://cdn.faire.com/fastly/708fc27a0ec94da5a41f623afbb6356bbca93fbb84bcf82d3920d294dabfea59.jpeg",
  thumbnailImageUrls: [
    "https://cdn.faire.com/fastly/708fc27a0ec94da5a41f623afbb6356bbca93fbb84bcf82d3920d294dabfea59.jpeg",
    "https://cdn.faire.com/fastly/02243d28fbcb5733111a303223fe941124642cdb4dbef89650cdd10bc85783b5.jpeg",
    "https://cdn.faire.com/fastly/8f5e4ebe34c8d721c576822cac4f9dfbed6473f7d7feec3e17a612100702c9c2.jpeg",
    "https://cdn.faire.com/fastly/321adc66aad27caa498ac86e63c8afb573362c65e1a4e525531782a55b45a40a.jpeg",
    "https://cdn.faire.com/fastly/98f166ace4ead9680cf5ac398b8465e08ab5a0aeb4f44270efc05223b53dad95.jpeg",
    "https://cdn.faire.com/fastly/e7a0e36f08404053d5b89f50fe918b1c74a026397435baa87477511010157362.jpeg",
  ],
  itemCount: 50,
  source: "eric_themes_ideas",
  teaser: "thi_e3064223f2",
  meta: {
    source: "mock",
    importedAt: "2026-04-19T23:00:00.000Z",
    importedBy: "board-demo-canonicalize",
  },
};
